export const formatSubdomain = (subdomain: string): string => `https://${subdomain}.hqo.co`;
